var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Routes',[(_vm.showPAAS)?_c('div',[_c('NavItem',{attrs:{"icon":"mdi-door","route":"/paas"}},[_vm._v(" PAAS ")])],1):_vm._e(),_c('ConfigRoutes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }